/**
 * Delivery por mapa + geocode backend (sin depender solo de Maps JS en el cliente).
 */

export const MIN_BACKEND_GEOCODE_ADDRESS_LENGTH = 8;

export function isGoogleMapsJsConfigured() {
  return Boolean(String(process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '').trim());
}

/** Normaliza dirección para geocode (Chile). */
export function normalizeDeliveryGeocodeQuery(address) {
  const addr = String(address || '').trim();
  if (!addr) return '';
  if (!/\bchile\b/i.test(addr)) {
    return `${addr}, Chile`;
  }
  return addr;
}

/**
 * ¿Debemos llamar POST /menu/:id/geocode-address?
 * Fallback cuando no hay pin (Maps JS no geocodificó o API key ausente en cliente).
 */
export function shouldRunBackendGeocode({
  isDemoCheckout,
  useAddressZonesForDelivery,
  serviceType,
  businessId,
  address,
  markerPosition,
}) {
  if (isDemoCheckout || useAddressZonesForDelivery) return false;
  if (serviceType !== 'delivery' || !businessId || markerPosition) return false;
  return String(address || '').trim().length >= MIN_BACKEND_GEOCODE_ADDRESS_LENGTH;
}

export function geocodeFailureMessage(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  return 'No pudimos ubicar esa dirección. Revisá calle, número y comuna.';
}

/** URL de Google Maps para compartir por WhatsApp (pin exacto o búsqueda por texto). */
export function buildGoogleMapsAddressUrl({ address, location } = {}) {
  const lat = Number(location?.lat);
  const lng = Number(location?.lng);
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return `https://www.google.com/maps?q=${lat},${lng}`;
  }
  const query = normalizeDeliveryGeocodeQuery(address);
  if (!query) return '';
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
}
